export const HORS_PAGE_URL = '/admin/housing-requests'

export const ADD_GHOR_PAGE_CONFIG = {
  breadcrumbs: [
    { title: 'Housing Requests', link: HORS_PAGE_URL },
    {
      title: 'Add Group Housing Request',
      readonly: true,
    },
  ],
  pageTitle: 'Add Group Housing Request',
}

export const ADD_SHOR_PAGE_CONFIG = {
  breadcrumbs: [
    { title: 'Housing Requests', link: HORS_PAGE_URL },
    {
      title: 'Add Housing Request',
      readonly: true,
    },
  ],
  pageTitle: 'Add Housing Request',
}

export const PWC_TITLE = 'pwc'
export const PWC_DEFAULT_CURRENCY_ID = 2 // GBP

export const PWC_HOUSING = 'Accommodation'
export const PWC_CONSULTANT = 'Arranger'
export const PWC_CONSULTANTS = 'Arrangers'
export const PWC_CORPORATE = 'Programme'

export const PWC_ADD_SHOR_PAGE_CONFIG: typeof ADD_SHOR_PAGE_CONFIG = {
  breadcrumbs: [
    { title: `${PWC_HOUSING} Requests`, link: HORS_PAGE_URL },
    {
      title: `Add ${PWC_HOUSING} Request`,
      readonly: true,
    },
  ],
  pageTitle: `Add ${PWC_HOUSING} Request`,
}

export const PWC_DICTIONARY = {
  housing: PWC_HOUSING,
  consultant: PWC_CONSULTANT,
  consultants: PWC_CONSULTANTS,
  corporate: PWC_CORPORATE,
  selectCorporate: 'Select Travel Programme',
  addShorPageConfig: PWC_ADD_SHOR_PAGE_CONFIG,
  hrBookings: 'Bookings',
  companiesManagement: 'Programmes Management',
  corporateFilter: 'Travel Programme',
  corporateFilterPlaceholder: 'Find travel programme',
  altoinsightCorporateFilter: 'Travel Programme',
  altoinsightCorporateFilterPlaceholder: 'Find travel programme',
  topCorporates: 'Top Travel Programmes',
  email: 'Worker Email',
} as const

export const PWC_COMPANY = {
  globalMobility: {
    slug: 'pwcglobalmobility',
    companyName: 'Global Mobility - LTA',
  },

  flyingStart: {
    slug: 'pwcflyingstart',
    companyName: 'Flying Start',
  },

  travel: {
    slug: 'pwctravel',
    companyName: 'Global Mobility - STA',
  },

  globalMobilityIt: {
    slug: 'pwcglobalmobilityit',
    companyName: 'Global Mobility - IT',
  },

  icaew: {
    slug: 'pwcicaew',
    companyName: 'ICAEW',
  },

  operate: {
    slug: 'pwcoperate',
    companyName: 'Operate',
  },

  internationalNewHires: {
    slug: 'pwcinternationalnewhires',
    companyName: 'International New Hires',
  },

  meetingAndEvents: {
    slug: 'pwcmeetingandevents',
    companyName: 'Meeting \u0026 Events',
  },

  projectsGroups: {
    slug: 'pwcprojectsgroups',
    companyName: 'Projects/Groups',
  },

  channelIslands: {
    slug: 'pwcchannelislands',
    companyName: 'Channel Islands',
  },

  businessTravel: {
    slug: 'pwcbusinesstravel',
    companyName: 'Business Travel',
  },
}

export const PWC_RMC_USER_COMPANIES = [
  PWC_COMPANY.businessTravel,
  PWC_COMPANY.operate,
  PWC_COMPANY.channelIslands,
]
export const PWC_RMC_BOOKER_COMPANIES = PWC_RMC_USER_COMPANIES
export const PWC_RMC_ADMIN_COMPANIES = [
  PWC_COMPANY.flyingStart,
  PWC_COMPANY.icaew,
  PWC_COMPANY.operate,
  PWC_COMPANY.internationalNewHires,
  PWC_COMPANY.meetingAndEvents,
  PWC_COMPANY.projectsGroups,
  PWC_COMPANY.channelIslands,
  PWC_COMPANY.businessTravel,
]

export const PWC_SPECIFIC_FILTERS = ['businessUnit', 'linesOfService']
export const PWC_ME_SPECIFIC_FILTERS = [
  'linesOfServicePwcMe',
  'guestGradePwcMe',
]
export const RMC_COMMON_FILTERS = [
  'unitType',
  'propertyType',
  'region',
  'currency',
  'country',
  'city',
  'corporate',
  'consultant',
]
